import { Injectable } from '@angular/core';
import { CatalogIndexResponse } from '@nousmedis/cc-types';
import { ApiService } from '../../api/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CatalogIndexService {
  private get urlBase(): string { return this.api.getBaseUrl(); }
  private get url(): string { return this.urlBase + '/api/v1/catalogs'; }

  constructor(private api: ApiService) {}

  getIndex(
    catalogId: string,
    page: number = 1,
    pageSize: number = 50,
    filters: { sku?: string; productName?: string; fascicle?: string; pageNumber?: string } = {},
    sortField?: string,
    sortOrder?: number
  ): Observable<CatalogIndexResponse> {
    const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
    if (filters.sku) params.set('sku', filters.sku);
    if (filters.productName) params.set('productName', filters.productName);
    if (filters.fascicle) params.set('fascicle', filters.fascicle);
    if (filters.pageNumber) params.set('pageNumber', filters.pageNumber);
    if (sortField) params.set('sortField', sortField);
    if (sortOrder != null) params.set('sortOrder', String(sortOrder));
    return this.api.get(`${this.url}/${catalogId}/index?${params.toString()}`);
  }
}
